module.exports = __webpack_public_path__ + "assets/8194f987c38ed041be0bdfcbff2ca587.mp3";